export class HelperService {
  constructor() {
  }

  public static initOpeningData(data) {
    if (!data.openingInfo || !data.openingInfo.length) {
      return null;
    }

    data.openingInfo.sort((a, b) => HelperService.getOrder(a) - HelperService.getOrder(b));

    const times = data.openingInfo.filter(el => {
      const startDate = new Date(el.startDate);
      startDate.setHours(23, 59, 59, 999);
      const endDate = new Date(el.endDate);
      endDate.setHours(23, 59, 59, 999);
      return !el.startDate && !el.endDate || (el.endDate && endDate >= new Date()) || (!el.endDate && el.startDate && startDate >= new Date());
    });
    if (times?.length > 0 && !data.oepningHours) {
      data.openingHours = { regularOpeningHours: HelperService.getDefaultOpeningHours() };
      data.openingHours.futurePeriod = [];
    }
    let hideMainOpeningHours = false;
    times.forEach(info => {
      if (!info.startDate && !info.endDate) {
        data.openingHours.regularOpeningHours = HelperService.convertOpeningInfo(data.openingHours.regularOpeningHours, info.days);
        data.openingHours.regularOpeningHoursTitle = info.titles;
      } else if (info.startDate && info.endDate && info.startDate !== info.endDate) {
        const openingHours: any = HelperService.convertPeriodOpeningInfo(data.openingHours.regularOpeningHours, info);
        hideMainOpeningHours = openingHours.hideMainOpeningHours === true ? true : hideMainOpeningHours;
        if (HelperService.checkFuturePeriod(info)) {
          data.openingHours.futurePeriod.push(HelperService.checkFuturePeriod(info));
        }
      } else if (info.startDate) {
        const openingHours = HelperService.convertSingleDate(data.openingHours.regularOpeningHours, info);
        Object.assign(data.openingHours, openingHours);
        if (HelperService.checkFutureSingle(info)) {
          data.openingHours.futurePeriod.push(HelperService.checkFutureSingle(info));
        }
      }
      data.openingHours.hideMainOpeningHours = hideMainOpeningHours;
    });

    return data.openingHours;
  }

  public static setEmptyStringsToNull(obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'string' && obj[key].trim() === '') {
        obj[key] = null;
      }
    }
    return obj;
  }

  public static translateDate(dateString, reverse = false) {
    const oldDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const translatedDays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
    const months = ['January', 'February', 'March', 'May', 'June', 'July', 'October', 'December'];
    const translatedMonths = ['Januar', 'Februar', 'März', 'Mai', 'Juni', 'Juli', 'Oktober', 'Dezember'];

    const replaceStrings = (str, from, to) => from.reduce((acc, item, index) => acc.replace(new RegExp(item, 'g'), to[index]), str);

    if (reverse) {
      dateString = replaceStrings(dateString, translatedDays, oldDays);
      dateString = replaceStrings(dateString, translatedMonths, months);
    } else {
      dateString = replaceStrings(dateString, oldDays, translatedDays);
      dateString = replaceStrings(dateString, months, translatedMonths);
    }

    return dateString;
  }

  private static getOrder(obj) {
    return !obj.startDate && !obj.endDate ? 0 : obj.startDate && obj.endDate ? 1 : obj.startDate ? 2 : 3;
  }

  private static getDefaultOpeningHours() {
    return {
      sunday: { open: false }, monday: { open: false }, tuesday: { open: false }, wednesday: { open: false }, thursday: { open: false },
      friday: { open: false }, saturday: { open: false }
    };
  }

  private static checkFutureSingle(openingInfo) {
    const startDate = new Date(openingInfo.startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let openingHours: any;
    if (startDate >= today) {
      openingHours = {};
      openingHours.titles = HelperService.getTexts(openingInfo.titles);
      openingHours.comment = HelperService.getTexts(openingInfo.comment);
      openingHours.startDate = openingInfo.startDate;
      openingHours.type = 'single';
      openingHours.open = openingInfo.days?.[0]?.open || openingInfo.open;
      openingInfo.times = openingInfo.days?.[0]?.times || openingInfo.times;
      openingHours.times = this.checkTimes(openingInfo.times);
    }
    return openingHours;
  }

  private static getTexts(data) {
    return (Array.isArray(data) && data.length) ? data : Object.keys(data || {}).length ? Object.keys(data || {}).map(key => {
      return { language: key, title: data[key] }
    }) : undefined;
  }

  private static checkFuturePeriod(openingInfo) {
    const endDate = new Date(openingInfo.endDate);
    const startDate = new Date(openingInfo.startDate);
    const today = new Date();
    const todayCopy = new Date();
    today.setHours(0, 0, 0, 0);
    todayCopy.setHours(0, 0, 0, 0);
    const sixMonthDate = new Date(todayCopy.setMonth(todayCopy.getMonth() + 6));
    let openingHours: any;
    if ((endDate > today) && (startDate < sixMonthDate)) {
      openingHours = {};
      openingHours.titles = HelperService.getTexts(openingInfo.titles);
      openingHours.comment = HelperService.getTexts(openingInfo.comment);
      openingHours.startDate = openingInfo.startDate;
      openingHours.endDate = openingInfo.endDate;
      openingHours.type = 'period';
      openingHours.days = {};
      for (let i = 0; i < openingInfo.days.length; i++) {
        openingHours.days[openingInfo.days[i].day] = {
          open: openingInfo.days[i].open,
          times: this.checkTimes(openingInfo.days[i].times)
        };
      }
    }
    return openingHours;
  }

  private static convertOpeningInfo(openingHours, openingInfo) {
    for (let i = 0; i < openingInfo.length; i++) {
      openingHours[openingInfo[i].day] = { open: openingInfo[i].open, times: this.checkTimes(openingInfo[i].times) }
    }
    return openingHours;
  }

  private static convertPeriodOpeningInfo(openingHours, openingInfo) {
    const startDate = new Date(openingInfo.startDate);
    const endDate = new Date(openingInfo.endDate);
    let nextOpenDay;
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    const weekdays = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };
    let hideMainOpeningHours = false;
    for (let i = 0; i < 7; i++) {
      if (startDate < HelperService.getWeekDay(date, i) && HelperService.getWeekDay(date, i) < endDate) {
        const dayInfo = openingInfo.days.find(el => el.day === weekdays[i]);
        if (dayInfo) {
          openingHours[weekdays[i]] = { open: dayInfo.open, times: this.checkTimes(dayInfo.times) };
        }
        hideMainOpeningHours = true;
      }
    }
    nextOpenDay = HelperService.getNextOpenDate(openingInfo);
    return { openingHours, nextOpenDay, hideMainOpeningHours };
  }

  private static getNextOpenDate(openingInfo) {
    const weekdays = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };
    let nextOpenDayInfo;
    const startDate = new Date(openingInfo.startDate);
    const startDateCopy = new Date(openingInfo.startDate);
    const endDate = new Date(openingInfo.endDate);
    for (let i = 0; i < 7; i++) {
      const searchDate = new Date(startDateCopy.setDate(startDate.getDate() + i));
      const searchDayInfo = openingInfo.days.find(el => el.day === weekdays[searchDate.getDay()]);
      if (searchDayInfo && searchDayInfo.open) {
        const nextOpenDay = HelperService.getNextDayOfWeek(searchDate.getDay());
        if (nextOpenDay <= endDate) {
          nextOpenDayInfo = {
            date: nextOpenDay.toISOString(), open: true, times: this.checkTimes(searchDayInfo.times), type: 'openingInfo'
          };
          break;
        }
      }
    }
    return nextOpenDayInfo;
  }

  private static getNextDayOfWeek(targetDay) {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysUntilTarget = (targetDay - dayOfWeek + 7) % 7;
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + daysUntilTarget);

    return nextDate;
  }

  private static getWeekDay(date, dayNumber) {
    const day = date.getDay();
    return new Date(date.setDate(date.getDate() - day + dayNumber));
  }

  private static convertSingleDate(openingHours, openingInfo) {
    const startDate = new Date(openingInfo.startDate);
    let nextOpenDay: any;
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    if (startDate > HelperService.getWeekDay(date, 0) && startDate < HelperService.getWeekDay(date, 6)) {
      nextOpenDay = { date: openingInfo.startDate, open: openingInfo.open, times: this.checkTimes(openingInfo.times), type: 'openingInfo' };
    } else if (startDate > HelperService.getWeekDay(date, 6) && openingInfo.open) {
      nextOpenDay = { date: openingInfo.startDate, open: true, times: this.checkTimes(openingInfo.times), type: 'openingInfo' };
    }
    return { openingHours, nextOpenDay };
  }

  private static checkTimes(times) {
    times = (times || []).map(el => {
      if (el.startTime && !el.endTime) {
        el.endTime = '00:00';
      }
      return el;
    });
    return times;
  }
}
